/**
 * Phase F (freemium): the subscription paywall redirect is retired.
 *
 * This file used to fetch `/api/user/status` on every SSR navigation and bounce
 * any paywall subject without an `active`/`trialing` subscription from the
 * creator.* / labels.* workspaces to `/plans`. Registration no longer has a plan
 * step: a signup lands straight in the dashboard on Creator-Free, a real tier
 * held WITHOUT any Stripe object, so there is no un-paid state to bounce. Paid
 * tiers are an in-app upgrade (account page → /pricing). The matching backend
 * gate is `server/middleware/04.subscription.ts`, also a no-op now.
 *
 * The logged-out branch is not missed: every page in those two workspaces
 * declares the `auth` or `creator` middleware, both of which already redirect
 * an anonymous visitor to the apex `/auth`.
 *
 * The file is kept as a no-op rather than deleted because removing a `.global`
 * middleware in Nuxt invalidates the SSR build cache; keeping the empty handler
 * is the safer one-line "off" switch (same call as
 * the onboarding-artist gate).
 */
export default defineNuxtRouteMiddleware(() => {
    return
})
